<template>
  <div class="microbiology-report">
    <form
      method="post"
      @submit="submitToGetReport"
    >
      <div class="microbiology-report__card">
        <h3>FILTROS</h3>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="30"
            md-flex-medium="30"
          >
            <div class="date-range-container">
              <DatePickerRange
                :date-selected.sync="date"
                :date-filter-alternative="true"
                :limit-data="limitData"
                :default-start-date="defaultStartDate"
                :default-end-date="defaultEndDate"
                :calendar-direction="'bottom'"
                :clear-button="false"
              />
            </div>
          </md-layout>

          <md-layout
            md-flex="30"
            md-flex-medium="30"
          >
            <md-input-container
              id="OsNumber"
              :class="{ 'md-input-invalid': errors.has('reportData.os') }"
            >
              <label>OS Alvaro</label>
              <md-input
                id="txtOsNumber"
                v-model="reportData.alvaroId"
                v-mask="'##########'"
                maxlength="10"
                type="text"
                placeholder="OS Alvaro"
                data-vv-validate-on="none"
                name="reportData.alvaroId"
                @keydown.enter.native="focusNextField('txtnamePatient')"
              />
            </md-input-container>
          </md-layout>
          <md-layout
            md-flex="40"
            md-flex-medium="40"
          >
            <md-input-container
              id="patientDoctorName"
              :class="{
                'md-input-invalid': errors.has('reportData.namePatient'),
              }"
            >
              <label>Nome do paciente</label>
              <md-input
                id="txtnamePatient"
                v-model="reportData.namePatient"
                maxlength="60"
                type="text"
                placeholder="Nome do paciente"
                data-vv-validate-on="none"
                title
                name="reportData.namePatient"
              />
            </md-input-container>
          </md-layout>
        </md-layout>

        <h3>Exportar como</h3>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout md-flex="100">
            <md-radio
              v-model="reportData.exportWay"
              :md-value="'csv'"
            >
              CSV
            </md-radio>
            <md-radio
              v-model="reportData.exportWay"
              :md-value="'excel'"
            >
              EXCEL
            </md-radio>
          </md-layout>
        </md-layout>
      </div>
      <div class="microbiology-report__box-submit">
        <button
          class="btn btn-primary btn-regular-size"
          type="submit"
        >
          Gerar relatório
        </button>
      </div>
      <iframe
        id="boxTable"
        style="display: none"
      />
    </form>
  </div>
</template>

<script>
import DatePickerRange from '@/components/common/DatePickerRange'
import { mask } from 'vue-the-mask'
import { formartDateFromArray } from '@/utils/date-utils'
import Moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import reportGeneratorService from '@/api/reportGenerator'
import convertJsonToCSV from '@/utils/convertJsonToCSV'
import convertJsonToExcel from '@/utils/convertJsonToExcel'

export default {
  name: 'MicrobiologyReport',
  components: {
    DatePickerRange
  },
  data: () => {
    return {
      reportData: {
        alvaroId: null,
        laboratoryId: null,
        releaseDateStart: null,
        releaseDateEnd: null,
        lisId: '',
        namePatient: '',
        exportWay: 'csv'
      },
      date: {
        start: new Date(),
        end: new Date()
      },
      limitDays: 120,
      headersTable: {
        idLab: 'Código do Laboratório Apoiado',
        osAlvaro: 'OS Alvaro',
        date: 'Data',
        namePatient: 'Nome do Paciente',
        exam: 'Exame',
        material: 'Material',
        result: 'Resultado'
      },
      fileName: 'Relatorio de Microbiologia - '
    }
  },
  computed: {
    ...mapGetters(['profile']),
    ...mapGetters(['getTodayDate']),
    today: function () {
      return formartDateFromArray(this.getTodayDate)
    },
    defaultStartDate: function () {
      return this.today
    },
    defaultEndDate: function () {
      return this.today
    },
    limitData: function () {
      let today = formartDateFromArray(this.getTodayDate)
      return Moment(today, 'DD/MM/YYYY')
        .subtract(this.limitDays, 'days')
        .toDate()
    }
  },
  methods: {
    ...mapActions(['updateToday']),
    submitAnalyticsEvent (data) {
      this.$analytics.pushAnalyticsEvent('ga-send', 'event', {
        category: 'Gerar relatórios',
        action: 'Gerar relatório',
        period: data.releaseDateStart + 'Até' + data.releaseDateEnd,
        'os-number': data.os,
        'patient-name': data.namePatient,
        format: data.exportWay,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    submitToGetReport (e) {
      e.preventDefault()

      if (
        !this.reportData.releaseDateStart &&
        !this.reportData.releaseDateEnd
      ) {
        this.reportData.releaseDateStart = Moment(this.date.start).format(
          'DD/MM/YYYY'
        )
        this.reportData.releaseDateEnd = Moment(this.date.end).format(
          'DD/MM/YYYY'
        )
      }

      const valueOnInput = document.getElementById('dateFilter').value
      const valueSelected = this.reportData.releaseDateStart + ' - ' + this.reportData.releaseDateEnd

      if (valueOnInput !== 'Hoje' && valueOnInput !== valueSelected) {
        this.reportData.releaseDateStart = valueOnInput.split(' - ')[0]
        this.reportData.releaseDateEnd = valueOnInput.split(' - ')[1]
      }

      this.reportData.laboratoryId = this.profile.id_laboratory

      reportGeneratorService
        .getMicrobiologyPartialReport(this.reportData)
        .then((response) => {
          if (response.data && response.data.length) {
            if (this.reportData.exportWay === 'csv') {
              convertJsonToCSV.buildObjectToCSV(
                response.data,
                this.headersTable,
                this.fileName
              )
            } else {
              convertJsonToExcel.generateObjectToExcel(
                response.data,
                this.headersTable,
                this.fileName
              )
            }
          } else {
            this.$emit('noResultsFound')
          }
        })

      this.submitAnalyticsEvent(this.reportData)
    }
  },
  watch: {
    date: function (newTime) {
      this.reportData.releaseDateStart = Moment(newTime.start).format(
        'DD/MM/YYYY'
      )
      this.reportData.releaseDateEnd = Moment(newTime.end).format('DD/MM/YYYY')
    }
  },
  created () {
    this.updateToday()
  },
  directives: {
    mask: mask
  }
}
</script>

<style lang="scss">
.microbiology-report {
  width: 100%;

  &__card {
    padding: 16px 20px 20px;
    background-color: #fff;
    position: relative;
    transition: min-height 0.6s, opacity 0.6s;
    opacity: 1;
    border-radius: 6px;
    margin-top: 15px;

    .md-layout {
      flex-wrap: nowrap;
    }
  }

  &__box-submit {
    display: flex;
    justify-content: flex-end;

    button {
      margin-top: 56px;
    }
  }

  h3 {
    font-size: 12px;
    letter-spacing: 0.1px;
    text-align: left;
    color: #7f1a54;
    font-weight: 600;
    text-transform: uppercase;
  }

  input {
    font-size: 14px !important;
    color: #303030 !important;
  }

  .date-range-container {
    width: 100%;

    .search-bar__date {
      margin: 0;
    }

    #datePickerSelect {
      &::after {
        content: " ";
        height: 1px;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.12);
        position: absolute;
        left: 0;
        transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
        background-color: #d3d3d3 !important;
        border-bottom: none !important;
        display: block !important;
      }

      input {
        color: #303030;
        overflow: hidden;
        font-size: 14px !important;
      }

      input::placeholder {
        color: red;
        text-align: left;
        font-size: 12px !important;
      }
    }
  }

  .md-radio {
    margin-right: 2em;
    margin-bottom: 0;

    .md-radio-container {
      background-color: #ebebeb;
      border: 2px solid #ebebeb;
    }
  }

  .md-theme-default.md-radio.md-checked .md-radio-container {
    background-color: #ebebeb;
    border: 2px solid #ebebeb;
  }

  .md-radio-label {
    color: #7a7a7a;
    text-align: left;
    font-size: 12px;
    font-weight: 500;
    padding-bottom: 10px;
    letter-spacing: 0.8px;
  }

  .md-theme-default.md-radio .md-radio-container::after {
    background-color: #7f1a54;
    transform: scale3D(1.2, 1.2, 1.2);
  }

  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  input[type="number"] {
    -moz-appearance: textfield !important;
    appearance: textfield !important;
  }
}
</style>
